import { Component } from '@angular/core';
import { ModalBase } from 'src/app/model/modal-base';
import { PlayerService } from 'src/app/services';

@Component({
    selector: 'app-request-signout-modal',
    styleUrls: ['./request-signout-modal.component.scss'],
    templateUrl: 'request-signout-modal.component.html'
})
export class RequestSignoutModalComponent extends ModalBase
{
    private readonly playerService: PlayerService;

    public constructor(playerService: PlayerService)
    {
        super();
        this.playerService = playerService;
    }

    public onExecuteSignoutClick(): void
    {
        this.playerService.signOut({ reroute: true, preserveOrder: false });
        this.close();
    }

    public onAbortSignoutClick(): void
    {
        this.close();
    }

    public open(): void
    {
        if (!this.isOpen())
        {
            super.open();
        }
    }

}


